// borderUtils.js
import * as turf from "@turf/turf";

/**
 * Calculates a negative buffer to shrink the polygon by `borderWidth` meters.
 * @param {object} polygonGeoJSON - A FeatureCollection or Feature (Polygon)
 * @param {number} borderWidth
 * @returns {object|null} offset polygon geojson
 */
export function calculateOffsetPolygon(polygonGeoJSON, borderWidth) {
  if (!polygonGeoJSON) return null;
  if(!borderWidth || borderWidth < 0) return polygonGeoJSON;
  try {
    /* const border = !borderWidth || borderWidth < 0 ? 0 : borderWidth */
    return turf.buffer(polygonGeoJSON.features[0], -borderWidth, { units: "meters" });
  } catch (err) {
    console.error("Error calculating offset polygon:", err);
    return null;
  }
}

/**
 * Calculates the maximum border width by finding the smallest distance 
 * from the centroid to any edge vertex of the polygon.
 */
export function calculateMaxBorderWidth(polygonGeoJSON) {
  if (!polygonGeoJSON) return 0;
  const centroid = turf.center(polygonGeoJSON); //or centroid
  const coords = polygonGeoJSON.features[0].geometry.coordinates[0];
  let minDistance = Infinity;
  coords.forEach((coord) => {
    const pt = turf.point(coord);
    const dist = turf.distance(centroid, pt, { units: "meters" });
    if (dist < minDistance) minDistance = dist;
  });
  return minDistance;
}
